import React from "react";

const TypeWriter = ({ text }) => {
  return (
    <div className="animated-letters">
      {text.split("").map((letter, index) => (
        <span
          key={index}
          className="letter"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          {letter}
        </span>
      ))}
    </div>
  );
};

export default TypeWriter;
